import { A4uImageAlbum as IconComponent } from '@adobe/react-spectrum-workflow/dist/ImageAlbum.js';
import { Icon } from '@react-spectrum/icon';
import React from 'react';
export default function ImageAlbum(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement(IconComponent, null));
}